module.exports = __webpack_public_path__ + "img/8.7789d2a6.png";